<template>
    <div id="RegistNavi" class="base">
        <div class="title-area">
            <div style="font-size: 24px; color: whitesmoke">Philips Care Portal</div>    
            <div style="font-size: 24px; color: whitesmoke">システム登録案内 </div>
        </div>
        <div class="agreement-area">
            <div id="item-contens">
                <div>
                    <b-button class="navibtn" @click="goto('hregist')">医療機関の方はこちら</b-button>
                </div>                    
                <div>
                    <b-button class="navibtn" @click="goto('dregist')">ディーラーの方はこちら</b-button>
                </div>
                <div>
                    <b-button class="navibtn" @click="goto('cregist')">企業の方はこちら</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: "RegistNavi",
  data() {
    return {
    };
  },
  methods: {
      goto: function(target) {
          this.$router.push("/" + target);
      }
  },
  computed: {
  },
  mounted: function(){
     //backgroundの変更
    document.documentElement.style.background = "rgb(0, 114, 218)";
  }  
};
</script>
<style lang="scss" scoped>
.base {
    padding-bottom: 50px;
}
.title-area{
    padding-top:50px;
    margin-bottom:25px;
}
.navibtn {
    width:500px;
    height:60px;
    font-size: 1.5rem;
    margin-top:30px;
}

</style>



// WEBPACK FOOTER //
// src/components/mock/guest/regist/RegistNavi.vue